export default __webpack_public_path__ + "static/media/clients 2.02b8708f.svg";